import React from 'react';
import PropTypes from 'prop-types';
import RowActionMenu from '../../components/RowActionMenu';

// Team card kebab menu — now a thin wrapper over the shared RowActionMenu so the
// dropdown styling stays consistent app-wide. Delete is the destructive (red) item.
function TeamEditColumn({ deleteTeam, editTeam }) {
  return (
    <RowActionMenu
      ariaLabel="Team options"
      triggerClassName={'ml-0.5 w-6 h-6 rounded text-ink-500 hover:bg-surface-1 flex '
        + 'items-center justify-center transition bg-transparent border-0 p-0'}
      items={[
        { label: 'Edit Team', onClick: editTeam },
        { label: 'Delete Team', onClick: deleteTeam, destructive: true },
      ]}
    />
  );
}

export default TeamEditColumn;

TeamEditColumn.propTypes = {
  deleteTeam: PropTypes.func.isRequired,
  editTeam: PropTypes.func.isRequired,
};
